import React from 'react';
import VendingMachineData from '@/vm/VendingMachineData';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  DeviceContextProvider,
  type OwnProps as DeviceContextProps
} from '~/context/common/DeviceContext';
import {
  OwnProps as StaticContextProps,
  StaticContextProvider
} from '~/context/common/StaticContext';

export type VendingMachineProvidersProps = {
  forAnalyticsProvider: {
    location?: { city: string; state: string };
  };
  forDeviceContext: DeviceContextProps;
  forStaticContext: StaticContextProps;
};

type OwnProps = React.PropsWithChildren<
  VendingMachineProvidersProps & {
    eventableProject: string;
    eventableTrack: string;
  }
>;

export default function VendingMachineProviders({
  children,
  eventableProject,
  eventableTrack,
  forAnalyticsProvider,
  forDeviceContext,
  forStaticContext
}: OwnProps) {
  return (
    <StaticContextProvider {...forStaticContext}>
      <AnalyticsProvider
        projectName={eventableProject}
        track={eventableTrack}
        {...forAnalyticsProvider}
      >
        <DeviceContextProvider {...forDeviceContext}>
          <VendingMachineData />
          {children}
        </DeviceContextProvider>
      </AnalyticsProvider>
    </StaticContextProvider>
  );
}
